// export default {
//     install(Vue, options) {
//         Vue.prototype.$confirm = function () {

//         }
//     }
// }




export default {
    async install(Vue) {
        let callBack = null;
        await Vue.mixin({
            created() {
                if(this.$options.name === "COMPLAINT_DIALOG_COMPONENT")
                    callBack = this.openDialog;
            }
        })
        Vue.prototype.$complaintDialog = callBack;
    }
};